export default __webpack_public_path__ + "images/VD.27b6cba.png";